export default __webpack_public_path__ + "static/media/article 8.4f68f0e3.png";